import React, { Component } from "react";
import { Destination as DestinationDefault } from "../common";
import Bubble from './components/Bubble';

export default class Destination extends Component {
  render() {
    return (
      <DestinationDefault
        {...this.props}
        project="laguna-park-2"
        projectMapChildren={(
          <g transform="translate(1350, 860)">
            <g id="lpark2-bubble-masterplan">
              <Bubble />
            </g>
          </g>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhuketLagunaPark2/Destination.js